import WineView from "@/views/admin/wine/WineView.vue";
import WineList from "@/views/admin/wine/WineList.vue";
import WineCreate from "@/views/admin/wine/WineCreate.vue";
import WineUpdate from "@/views/admin/wine/WineUpdate.vue";
import { ROLES } from "@/config/Roles";
import auth from "@/middlewares/AuthMiddleware";
import i18n from "@/locales";

export default [
  {
    path: "/exhibitor-wine",
    component: WineView,
    meta: {
      visibleInAside: true,
      roles: [ROLES.EXHIBITOR],
      title: String(i18n.t("menu.wine")),
      middleware: [auth],
      avoidBack: true
    },
    children: [
      {
        path: "",
        name: "exhibitor_wine",
        component: WineList,
        meta: {
          visibleInAside: true,
          title: "",
          roles: [ROLES.EXHIBITOR],
          middleware: [auth]
        }
      },
      {
        path: "create",
        name: "exhibitor_wine_create",
        component: WineCreate,
        meta: {
          visibleInAside: true,
          roles: [ROLES.EXHIBITOR],
          title: String(i18n.t("general.wine_add")),
          middleware: [auth],
          avoidBack: true
        }
      },
      {
        path: "edit/:id",
        name: "exhibitor_wine_edit",
        component: WineUpdate,
        meta: {
          roles: [ROLES.EXHIBITOR],
          title: String(i18n.t("general.edit_wine")),
          middleware: [auth]
        }
      }
    ]
  }
];
